import { IModelAssignmentResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export type AnalyticsModelsAssignmentFilter = Readonly<{
    corporationId?: string;
    locationId?: string;
    nameSearch?: string;
    analyticsModelId?: string;
}>;

export type UsePagedAnalyticsModelDataSourceOptions = BaseDataSourceOptions<
    IModelAssignmentResponse,
    AnalyticsModelsAssignmentFilter
>;

export type PagedAnalyticsModelAssignmentDataSource = PagedDataSource<
    IModelAssignmentResponse,
    AnalyticsModelsAssignmentFilter
>;

const queryFn: DataSourceQuery<
    IModelAssignmentResponse,
    AnalyticsModelsAssignmentFilter
> = ({
    filter: { locationId, corporationId, nameSearch, analyticsModelId },
    sort,
    page,
    pageLimit,
}) => {
    const filter = Filter.and(
        corporationId ? Filter.eq('CorporationId', corporationId) : undefined,
        locationId ? Filter.eq('LocationId', locationId) : undefined,
        nameSearch
            ? Filter.or(
                  Filter.contains('AnalyticsModelName', nameSearch),
                  Filter.contains('RootGroupName', nameSearch),
              )
            : undefined,
        analyticsModelId ? Filter.eq('AnalyticsModelId', analyticsModelId) : undefined,
    );
    const orderBy = buildOrderBy(sort);

    return toDataSourceResult(
        sdClient.getAnalyticsAssignments({ filter, page, pageLimit, orderBy }),
    );
};

export function usePagedGroupAnalyticsModelDataSource(
    options: UsePagedAnalyticsModelDataSourceOptions,
): PagedAnalyticsModelAssignmentDataSource {
    return usePagedDataSource({ ...options, query: queryFn });
}
